import { render, staticRenderFns } from "./AddSupplier.vue?vue&type=template&id=87509606&"
import script from "./AddSupplier.vue?vue&type=script&lang=js&"
export * from "./AddSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports